<script>
  import Page from '@components/page'
  import Button from '@components/buttons/button.svelte'
  import { House, TriangleAlert, ChevronRight } from 'lucide-svelte'

  let title = "Page not found"
</script>

<Page.Layout {title}>

  <Page.Navigation {title} Icon={TriangleAlert} />

  <Page.Titles title="Error | 404" subtitle="Page not found" />

  <Page.Content>
    <p class="prose">
      The page you're looking for doesn't exist or has been moved.
    </p>
    <Button variant="link" path="/" text="Homepage" BeforeIcon={House} class="mt-6 text-sm hover:underline" Icon={ChevronRight} />
  </Page.Content>

</Page.Layout>
